import React, { Fragment, useContext, useState, useEffect, useCallback } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Breadcrumbs } from '../../../../../AbstractElements';
import CustomizerContext from '../../../../../_helper/Customizer';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { RegionalContinentApi, RegionalCountryApi, ZoneApi } from '../../../../../api';
import { toast } from 'react-toastify';
import CardRibbonWithForm from '../../../../Common/Component/CardRibbonWithForm';
import {base_form_fields2, createDropdownField, short_name_field} from '../../../../../Data/FormField/PublicData';
import useAxiosPrivate from '../../../../../Hooks/useAxiosPrivate';
import { Zone } from '../../../../../Constant';

const ZoneNew = () => {
  const history = useNavigate();
  const { layoutURL } = useContext(CustomizerContext);
  const axiosPrivate = useAxiosPrivate()
  const lists = `${process.env.PUBLIC_URL}/public-data/zones/${layoutURL}`;

  const { formState: { errors },} = useForm(); 

  const [formFields, setFormFields] = useState(base_form_fields2(`${Zone}`));
  const [isNewFieldAdded, setIsNewFieldAdded] = useState(false);

  const countryDropdownField = createDropdownField(axiosPrivate,
    'regional_country_id',
    'regional_country_id',
    'Country',
    `${RegionalCountryApi}`,
    '', 12
  ); 

  const continentDropdownField = createDropdownField(axiosPrivate,
    'continent_id',
    'continent_id',
    'Continent',
    `${RegionalContinentApi}`,
    countryDropdownField,
    12
  );
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!isNewFieldAdded) {
          const updatedFields = [continentDropdownField, countryDropdownField, ...formFields];
          const indexOfName = updatedFields.findIndex((formField) => formField.id === 'is_active');
          updatedFields.splice(indexOfName , 0, short_name_field());
          
          await continentDropdownField.fetchOptions();
          setFormFields(updatedFields);
          setIsNewFieldAdded(true);
        }
      } catch (error) {
        console.error('Error fetching options:', error);
      }
    };
    fetchData();

  }, [formFields, isNewFieldAdded]);  

  continentDropdownField.onChange = async (selectedContinentId, updatedFields) => { 
    const countryField = updatedFields.find((field) => field.id === 'regional_country_id');
    
    if (countryField) {
      await countryField.fetchOptions(selectedContinentId);
      setFormFields([...updatedFields]);
    } 
  };
  
  const addNewRecord =  async (newRecord) => {
      if (newRecord === '') { 
        errors.showMessages();
      }

      const newRecordTemp = {
          regional_country_id: newRecord.regional_country_id,
          name: newRecord.name,
          short_name: newRecord.short_name,
          description: newRecord.name,
          is_active: newRecord.is_active,
      };

      try {
          await axiosPrivate.post(ZoneApi, newRecordTemp).then((resp) => {
            toast.success(`${resp.data.name} is successfully added.`)
            history(lists);
          });
      } catch (error) {
        if (error.response && error.response.status === 422) {
            toast.error('Validation Errors');
          } else if (error.response && error.response.status === 400) {
            toast.error(error.response.data.detail);
          } else {
            toast.error('Form submission error');
          }
        throw error;
    }   
  };


  return (
    <Fragment>
      <Breadcrumbs parent="Public Data" title="New Zone" mainTitle="New Zone" />
      <Container fluid={true}>
        <Row>
          <Col sm='10'>
            <CardRibbonWithForm formFields={formFields} onSubmit={addNewRecord} ribbonUrl={lists} />
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default ZoneNew;